import { Dispatch } from "redux";
import { QueryParamsMap } from "app/RouteDefinition";
import { pageLoaded } from "app/pages/EarlyBirdOfferList/actions";
import { Action } from "app/pages/EarlyBirdOfferList/actionTypes";
import { getEarlyBirdOffers } from "app/shared/api";
import { getSelectedDivisionId } from "app/pages/AgentPricing/utils/division";

export function loadPage(
    dispatch: Dispatch<Action>,
    _qs: QueryParamsMap
): Promise<void> {
    const divisionId = getSelectedDivisionId();
    if (!divisionId) {
        return Promise.reject(
            new Error("Missing division (select a division first).")
        );
    }

    return getEarlyBirdOffers(divisionId).then((offers) => {
        dispatch(pageLoaded(offers, divisionId));
    });
}